__turbopack_context__.v({
  "root": "close-chat-apply-modal-module-scss-module__S7YDLa__root",
});
